import client from './client';

export const getClinics = client().get('/clinics');
